module.exports = __webpack_public_path__ + "img/snowflake.a40236d8.png";